<template>
  <div>
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <el-form ref="searchForm" :inline="true" class="" :model="searchForm">
          <el-form-item label="合同编号:" prop="contractNum">
            <el-input v-model.trim="searchForm.contractNum" placeholder="请输入合同编号编号" />
          </el-form-item>
          <el-form-item label="项目名称:" prop="projectName">
            <el-input v-model.trim="searchForm.projectName" placeholder="请输入项目名称" />
          </el-form-item>
          <el-form-item label="合同时间:" prop="contractSelectDate">
            <el-date-picker
              v-model="contractSelectDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              placeholder="选择日期范围"
              clearable
              style="width: 300px;"
              @change="changeDatePicker(true)"
            />
          </el-form-item>
          <el-form-item label="开票时间:" prop="invoiceSelectDate">
            <el-date-picker
              v-model="invoiceSelectDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              placeholder="选择日期范围"
              clearable
              style="width: 300px;"
              @change="changeDatePicker(false)"
            />
          </el-form-item>

          <el-button type="primary" :loading="isLoading" @click="doSearch">
            查询
          </el-button>
          <el-button type="default" @click="resetForm('searchForm')">
            重置
          </el-button>
        </el-form>
      </div>
    </div>
    <!-- 表格-->
    <div>
      <div class="operate-btn-wrap">
        <el-button type="primary" :loading="isExportLoading" @click="conditionsExport">
          按条件导出
        </el-button>
      </div>
      <el-table v-loading="isLoading" :data="tableData" style="width: 100%" border>
        <el-table-column prop="contractNum" label="合同编号" align="left" fixed="left" width="140" />
        <el-table-column prop="contractDate" label="合同日期" align="left" width="140" />
        <el-table-column prop="projectName" label="项目名称" align="left" fixed="left" min-width="160px" />
        <el-table-column prop="invoiceAmount" label="订单金额(元)" align="right" header-align="left" />
        <el-table-column prop="invoiceNoticeNum" label="开票通知单号" align="left" />
        <el-table-column prop="invoiceDate" label="开票日期" align="left" />
        <el-table-column prop="invoiceCode" label="发票代码" align="left" />
        <el-table-column prop="digitalPdfFileUrl" label="数电PDF文件" align="left" fixed="right" width="100">
          <template v-slot="{row}">
            <el-button type="text" @click="downloadPdfFile(row.digitalPdfFileUrl)">
              下载
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="digitalXmlFileUrl" label="数电XML文件" align="left" fixed="right" width="100">
          <template v-slot="{row}">
            <el-button type="text" @click="downloadXmlFile(row.digitalXmlFileUrl)">
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="result-table-pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
// exportProductInfo
import { getElectronicTableData, exportElectronicTableData } from '@/API';
import { downloadBlobFile } from '@/libs/util.js';
export default {
  components: {
  },
  data () {
    return {
      tableData: [],
      isExportLoading: false,
      isLoading: false,
      contractSelectDate: [], // 合同时间,选择
      invoiceSelectDate: [], // 开票时间,选择
      searchForm: {
        contractNum: null, // 合同编号
        projectName: null, // 项目名称
        contractDateStart: null, // 合同开始时间
        contractDateEnd: null, // 合同结束时间
        invoiceDateStart: null, // 开票开始时间
        invoiceDateEnd: null // 开票结束时间
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      downloadFileToken: '',
      uploadUrl: '',
      downFileUrl: ''
    };
  },
  mounted () {
    this.getTableDataList();
  },
  methods: {
    doSearch () {
      this.getTableDataList();
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.page.currentPage = 1;
      this.searchForm.contractNum = null;
      this.searchForm.projectName = null;
      this.searchForm.contractDateStart = null;
      this.searchForm.contractDateEnd = null;
      this.searchForm.invoiceDateStart = null;
      this.searchForm.invoiceDateEnd = null;
      this.contractSelectDate = [];
      this.invoiceSelectDate = [];
      this.doSearch();
    },
    // 选择日历
    changeDatePicker (val) {
      if (val) {
        // 如果选择的是合同时间
        this.searchForm.contractDateStart = this.contractSelectDate ? this.contractSelectDate[0] : null;
        this.searchForm.contractDateEnd = this.contractSelectDate ? this.contractSelectDate[1] : null;

        // 如果开票时间没有选择，则清空开票时间字段
        if (!this.invoiceSelectDate || this.invoiceSelectDate.length === 0) {
          this.searchForm.invoiceDateStart = null;
          this.searchForm.invoiceDateEnd = null;
        }
      } else {
        // 如果选择的是开票时间
        this.searchForm.invoiceDateStart = this.invoiceSelectDate ? this.invoiceSelectDate[0] : null;
        this.searchForm.invoiceDateEnd = this.invoiceSelectDate ? this.invoiceSelectDate[1] : null;

        // 如果合同时间没有选择，则清空合同时间字段
        if (!this.contractSelectDate || this.contractSelectDate.length === 0) {
          this.searchForm.contractDateStart = null;
          this.searchForm.contractDateEnd = null;
        }
      }
    },
    // 按条件导出
    conditionsExport () {
      // 验证日期范围是否超过30天的通用函数
      const validateDateRange = (startDate, endDate, message) => {
        if (startDate && endDate) {
          const start = new Date(startDate);
          const end = new Date(endDate);
          const diff = (end - start) / (1000 * 60 * 60 * 24);
          if (diff > 30) {
            this.$message.error(message);
            return false;
          }
        }
        return true;
      };
      // 验证合同时间
      if (!validateDateRange(this.contractSelectDate?.[0], this.contractSelectDate?.[1], '合同时间范围不能超过30天')) {
        return;
      }
      // 验证开票时间
      if (!validateDateRange(this.invoiceSelectDate?.[0], this.invoiceSelectDate?.[1], '开票时间范围不能超过30天')) {
        return;
      }
      // 检查搜索条件是否为空
      const { contractNum, contractDateStart, contractDateEnd, invoiceDateStart, invoiceDateEnd } = this.searchForm;
      const hasValidSearchCriteria = [contractNum, contractDateStart, contractDateEnd, invoiceDateStart, invoiceDateEnd].some(value => value !== null);

      if (!hasValidSearchCriteria) {
        this.$message.warning('请选择查询条件!');
      } else {
        this.exportElectronicTableDataMethods();
      }
    },
    // 下载PDF文件
    downloadPdfFile (url) {
      if (!url) {
        this.$message.error('发票可能还未开出，请稍后再进行下载!');
        return false;
      }
      window.open(url);
    },
    // 下载XML文件
    downloadXmlFile (url) {
      if (!url) {
        this.$message.error('发票可能还未开出，请稍后再进行下载!');
        return false;
      }
      window.open(url);
    },
    handleSizeChange (size) {
      this.page.pageSize = size;
      this.doSearch();
    },
    handleCurrentChange (index) {
      this.page.pageIndex = index;
      this.doSearch();
    },
    // 获取列表
    getTableDataList () {
      this.isLoading = true;
      let params = {
        ...this.searchForm,
        pageSize: this.page.pageSize,
        pageNo: this.page.currentPage
      };
      getElectronicTableData(params).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.tableData = data.list || [];
          this.page.total = data.total || 0;
          this.isLoading = false;
        }
      }).catch((err) => {
        console.log(err);
        this.isLoading = false;
      });
    },
    // 导出
    exportElectronicTableDataMethods () {
      this.isExportLoading = true;
      let params = {
        ...this.searchForm,
        pageSize: this.page.pageSize,
        pageNo: this.page.currentPage
      };
      exportElectronicTableData(params).then((res) => {
        // if (Number(res.data.status) === 200) {
        downloadBlobFile({
          content: res.data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileName: '我的发票'
        });
        this.isExportLoading = false;
        // }
      }).finally(() => {
        this.isExportLoading = false;
      });
    }
  }
};
</script>

<style scoped>
.result-table-pagination{
  text-align: right;
  margin-top: 10px
}
</style>
